<template>
    <div>
        <h2>{{$t('rules.automaticRules.title')}}</h2>
        <p class="description">{{$t('rules.automaticRules.description')}}</p>
        <b-container>
            <b-row v-for="(r,ind) in value" :key="ind">
                <div class="delete" @click="doUp(ind)">
                    <font-awesome-icon icon="arrow-alt-up" :class="{hidden:ind === 0}" size="lg"></font-awesome-icon>
                </div>
                <div class="delete" @click="doDown(ind)">
                    <font-awesome-icon icon="arrow-alt-down"  :class="{hidden:ind === value.length - 1}"
                            size="lg"></font-awesome-icon>
                </div>
                <b-col @click="$router.push(`rules/a/${ind}`)">
                    {{r.name}}
                </b-col>
                <div class="delete" @click="doDelete(ind)">
                    <font-awesome-icon icon="times" size="lg"></font-awesome-icon>
                </div>
            </b-row>
            <b-row v-if="!value.length">
                <b-col @click="doAdd">{{$t('rules.automaticRules.noRules')}}</b-col>
            </b-row>
        </b-container>

        <b-button variant="primary" @click="doAdd">{{$t('rules.automaticRules.add')}}</b-button>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'automaticRules',
  components: { FontAwesomeIcon },
  data: function() {
    return {
    };
  },
  props: {
    value: Array
  },
  methods: {
    doAdd() {
      this.$router.push('rules/a/-1');
    },
    doDelete(ind) {
      let r = this.value;
      r.splice(ind, 1);
      this.$store.dispatch('setSetting', { name: 'msgrules', value: r });
    },
    doUp(ind) {
      console.log('do up');
      if (ind > 0) {
        let r = cloneDeep(this.value);
        const y = r[ind].order;
        r[ind].order = r[ind - 1].order;
        r[ind - 1].order = y;
        this.$store.dispatch('setSetting', { name: 'msgrules', value: r });
      }
    },
    doDown(ind) {
      console.log('do up');
      if (ind < this.value.length - 1) {
        let r = cloneDeep(this.value);
        const y = r[ind].order;
        r[ind].order = r[ind + 1].order;
        r[ind + 1].order = y;
        this.$store.dispatch('setSetting', { name: 'msgrules', value: r });
      }
    }
  }
};
</script>

<style scoped lang="scss">
    svg.hidden {
        opacity: 0;
    }
</style>
